import { useRecoilCallback } from 'recoil'
import { editorClipboardAtom, itemsSelector } from 'atoms'
import { canvasPageIdAtom } from '@/atoms/_editorAtoms'
import {
  editorTextBoxDocumentsSelector,
  editorTextBoxDraftsAtom,
} from '@/atoms/editorTextBoxAtoms'
import {
  editorTextBoxCurrentDocument,
  isEditorTextBoxItem,
} from '@/utils/editor-text-box/editorTextBoxAdapter'

export const useCopyMultiItemsToClipboard = () =>
  useRecoilCallback(
    ({ snapshot, set }) =>
      async () => {
        const items = await snapshot.getPromise(itemsSelector())

        const pageId = await snapshot.getPromise(canvasPageIdAtom)
        const [drafts, results] = pageId
          ? await Promise.all([
              snapshot.getPromise(editorTextBoxDraftsAtom),
              snapshot.getPromise(editorTextBoxDocumentsSelector(pageId)),
            ])
          : [{}, null]

        const copiedItems = items.map((item) => {
          if (!isEditorTextBoxItem(item)) return { ...item }
          return {
            ...item,
            editorTextBoxDocument:
              editorTextBoxCurrentDocument({ item, results, drafts }) ??
              undefined,
          }
        })
        set(editorClipboardAtom, copiedItems)
      },
    [],
  )

export default useCopyMultiItemsToClipboard
